/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import IconTextRow from "./IconTextRow";
import {IconScheduleTable, TimePickerChip} from "../../../../../../../../components/buttons/IconButtons";
import {EMPTY_VALUES, getDateFormat, getTimeFormat} from "../../../../../../../../Apis/functions";

/**
 * Date and time of a movement, read side by side because they name the same
 * moment.
 *
 * A moment nobody has registered yet is read with the label the section
 * declares for it, because the movements the gate still has to write are the
 * ones waiting for it and not the ones that carry no value.
 */
const DateTimeSection = ({t, date, emptyText = EMPTY_VALUES.DEFAULT}) => {
    return (
        <>
            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>{t('date_and_time')}</p>
            <div className='row mx-0'>
                <div className='col-sm-12 col-md-6 px-0'>
                    <IconTextRow
                        Icon={IconScheduleTable}
                        text={date ? getDateFormat(date, false) : emptyText}
                    />
                </div>
                <div className='col-sm-12 col-md-6 px-0'>
                    <IconTextRow
                        Icon={TimePickerChip}
                        text={date ? getTimeFormat(date, false) : emptyText}
                    />
                </div>
            </div>
        </>
    );
};

export default DateTimeSection;
